module.exports = __webpack_public_path__ + "static/media/neutral_medium.7d4d023d.jpg";